<template>
  <div v-if="location">

    <h2 class="mb-4 fw-bold">
      {{ location.title }}
    </h2>

    <p class="mb-3">
      {{ location.address }}
    </p>

    <div v-if="location.mapEmbed" class="ratio ratio-16x9">
      <iframe
        :src="location.mapEmbed"
        style="border:0;"
        allowfullscreen
        loading="lazy"
      ></iframe>
    </div>

  </div>
</template>

<script>
export default {

  name: 'LocationPage',

  props: ['pages'],

  computed: {
    location () {
      return this.pages?.location || null
    }
  }

}
</script>
